<template>
  <div id="carousel" class="carousel">
    <div class="carousel-viewport">
      <div class="carousel-slider">
        <div class="carousel-cell">
          <img alt="hadware" src="../assets/index/hadware-min.png" style="z-index: 11" />
        </div>
        <div class="carousel-cell">
          <img alt="red" src="../assets/fabrica/processor-3720053_1920.jpg" style="z-index: 10" />
        </div>
         <div class="carousel-cell" style="z-index: 12">
            <img alt="reporte" src="../assets/fabrica/electronic-devices-514180_1920.jpg" />
         </div>
      </div>
    </div>

    <ol class="carousel-dots">
      <li class="dot" aria-label="Page dot 1" @click="moveCarousel(slideIndex = 1)"></li>
      <li class="dot selected" aria-label="Page dot 2" aria-current="step" @click="moveCarousel(slideIndex = 2)"></li>
      <li class="dot" aria-label="Page dot 3" aria-current="step" @click="moveCarousel(slideIndex = 3)"></li>
    </ol>
  </div>
</template>

<script>
   export default {
      name: "Carrusel",
     props: {
       index: {
         type: Number,
         default: 1
       }
     },
     mounted: function () {
       this.moveCarousel(this.$props.index);
       window.addEventListener('resize', (event) => {
         if (document.getElementById('carousel'))
           document.getElementById('carousel').style.height = document.getElementsByClassName('carousel-cell')[0].children[0].height + "px";
       });
       this.insertHeighImage();
     },
     updated: function () {
       document.getElementById('carousel').style.height = document.getElementsByClassName('carousel-cell')[0].children[0].height + "px";
     },
     beforeDestroy: function () {
       window.removeEventListener('resize', (event) => {});
       clearTimeout(this.$data.timer);
       this.$data.timer = 0;
     },
     methods: {
       insertHeighImage () {
         if (document.getElementsByClassName('carousel-cell')[0].children[0].height > 0) {
           this.$forceUpdate();
         } else
           setTimeout(() => {
             this.insertHeighImage();
           }, 50)
       },
       moveCarousel(position) {
         clearTimeout(this.$data.timer);
         this.$data.timer = 0;

         let x = document.getElementsByClassName("carousel-cell");
         let dot = document.getElementsByClassName("dot");
         if (position > x.length) {
           this.$data.slideIndex = 1
         }
         if (position < 1) {
           this.$data.slideIndex = x.length
         }

         for (let i = 0; i < x.length; i++) {
           x[i].className = "carousel-cell";
           dot[i].className = "dot";
         }

         x[this.$data.slideIndex-1].className = "carousel-cell selected";
         dot[this.$data.slideIndex-1].className = "dot selected";

         this.$data.timer = setTimeout(() => {
           this.moveCarousel(this.$data.slideIndex += 1);
         }, 4000)

       }
     },
     data: function () {
       return {
         slideIndex: this.$props.index,
         timer: 0
       }
     }
   }
</script>

<style scoped lang="scss">
  @import "../style/base";

  #carousel {
    margin-bottom: 20px;
    position: relative;
  & .carousel-viewport {

  & .carousel-slider {
      position: relative;
  & .carousel-cell {
      position: absolute;
      opacity: 0;
      z-index: 9;

  &:not(.selected) {
     animation-name: outFade;
     animation-duration: 1s;
   }

  &.selected {
     animation-name: fade;
     animation-duration: 3s;
     z-index: 10;
     opacity: 1;
   }

  & img {
      width: 100%;
      height: auto;
    }
  }
  }

  }

  & .carousel-dots {
      position: absolute;
      bottom: -23px;
      z-index: 20;
      margin: 0;
      padding: 0;
      left: 50%;
      transform: translateX(-50%);
      height: 5px;
  & li {
      list-style: none;
      width: 35px;
      height: 5px;
      opacity: 1;
      background: #063e69;
      border: 0px solid white;
      display: inline-block;
      cursor: pointer;

  &:HOVER {
     background: #F9423A;
     box-shadow: 0 2px 7px 0 rgba(249,66,58,0.40);
     opacity: .85;
   }

  &.selected {
     background: #fec303;
     box-shadow: 0 2px 7px 0 rgba(249,66,58,0.50);
     opacity: 1;
   }
  }
  }

  }
</style>
